import { alert, confirm } from './utils/message-box';

export async function formResponseErrorHandler(failMessages, { response }) {
  if (!response) {
    return await alert(
      '서버와의 연결이 원활하지 않습니다. 네트워크 연결을 확인해주세요.',
      '회원 등록 실패'
    );
  }

  if (failMessages.error_code[response.data.error_code]) {
    return await failMessages.error_code[response.data.error_code].handler(
      response
    );
  }

  if (failMessages.status[response.status]) {
    return await failMessages.status[response.status].handler();
  }

  return await failMessages.unknown.handler();
}

export const MEMBERSHIP_CREATE_IN_MEMBER_REGISTER_FAIL_MESSAGES = {
  status: {
    400: {
      async handler() {
        const title = '회원 등록 실패',
          message =
            '회원은 등록되었으나 입력해주신 회원권 정보 중 빈 값이 존재하여 회원권이 저장되지 않았습니다.';

        await alert(message, title);
      }
    }
  },
  error_code: {
    '100': {
      async handler() {
        const title = '무료 플랜 제한 인원을 초과하셨습니다.',
          message =
            '계속해서 이용하시려면 유료 플랜으로 전환해주세요. 전환이 완료될 때까지 본 회원은 승인 대기 상태로 유지됩니다.',
          confirmButtonText = '지금 바로 플랜 전환',
          cancelButtonText = '확인';

        try {
          await confirm(message, title, {
            confirmButtonText,
            cancelButtonText
          });
          window.open(
            'https://bit.ly/3qv0GAo?utm_source=wh_exceed_numb_button',
            '_blank'
          );
        } catch (err) {}
      }
    },
    '102': {
      async handler() {
        const title = '회원권 수정 불가';
        const message = '회원권의 시작일은 종료일보다 뒤로 조정될 수 없습니다.';

        await alert(message, title);
      }
    },
    '104': {
      async handler() {
        const title = '회원 등록 실패',
          message =
            '회원은 등록되었으나 입력해주신 회원권 정보 중 최대 수강 횟수는 수강 횟수보다 낮게 설정될 수 없어 저장되지 않았습니다.';

        await alert(message, title);
      }
    }
  },
  unknown: {
    async handler(data) {
      await alert(
        '회원은 등록되었으나 아래의 오류로 인해 회원권 정보가 저장되지 않았습니다. \n' +
          JSON.stringify(data),
        '회원 등록 실패'
      );
    }
  }
};

export const MEMBERSHIP_CREATE_FAIL_MESSAGES = {
  error_code: {
    '100': {
      async handler() {
        const title = '무료 플랜 제한 인원을 초과하셨습니다.',
          message =
            '계속해서 이용하시려면 유료 플랜으로 전환해주세요. 전환이 완료될 때까지 본 회원은 승인 대기 상태로 유지됩니다.',
          confirmButtonText = '지금 바로 플랜 전환',
          cancelButtonText = '확인';

        try {
          await confirm(message, title, {
            confirmButtonText,
            cancelButtonText
          });
          window.open('https://bit.ly/3qv0GAo?utm_source=white', '_blank');
        } catch (err) {}
      }
    },
    '102': {
      async handler() {
        const title = '회원권 수정 불가',
          message = '회원권의 시작일은 종료일보다 뒤로 조정될 수 없습니다.';

        await alert(message, title);
      }
    },

    '104': {
      async handler() {
        const title = '회원권 등록 불가',
          message = '최대 수강 횟수는 수강 횟수보다 낮게 설정될 수 없습니다.';

        await alert(message, title);
      }
    }
  },
  status: {
    400: {
      async handler() {
        const title = '회원권 저장 실패',
          message =
            '입력해주신 회원권 정보 중 빈 값이 존재하여 회원권이 저장되지 않았습니다. 모든 정보를 입력해주세요.';

        await alert(message, title);
      }
    }
  },
  unknown: {
    async handler(data) {
      await alert(
        '아래의 오류로 인해 회원권 정보가 저장되지 않았습니다. \n' +
          JSON.stringify(data),
        '회원권 저장 불가'
      );
    }
  }
};

export const MEMBERSHIP_MODIFY_FAIL_MESSAGES = {
  error_code: {
    '100': {
      async handler() {
        const title = '무료 플랜 제한 인원을 초과하셨습니다.',
          message =
            '계속해서 이용하시려면 유료 플랜으로 전환해주세요. 전환이 완료될 때까지 본 회원은 승인 대기 상태로 유지됩니다.',
          confirmButtonText = '지금 바로 플랜 전환',
          cancelButtonText = '확인';

        try {
          await confirm(message, title, {
            confirmButtonText,
            cancelButtonText
          });

          window.open('https://bit.ly/3qv0GAo?utm_source=white', '_blank');
        } catch (err) {}
      }
    },

    '101': {
      async handler() {
        const title = '회원권 수정 불가',
          message = '회원권 기간을 벗어난 홀딩이 존재합니다.';

        await alert(message, title);
      }
    },

    '102': {
      async handler() {
        const title = '회원권 수정 불가',
          message = '회원권의 시작일은 종료일보다 뒤로 조정될 수 없습니다.';

        await alert(message, title);
      }
    },

    '103': {
      async handler() {
        const title = '회원권 수정 불가',
          message =
            '수강 횟수를 이미 예약/출석으로 소비된 전체 횟수보다 낮게 변경할 수 없습니다.';

        await alert(message, title);
      }
    },

    '104': {
      async handler() {
        const title = '회원권 수정 불가',
          message = '최대 수강 횟수는 수강 횟수보다 낮게 설정될 수 없습니다.';

        await alert(message, title);
      }
    }
  },
  status: {
    400: {
      async handler() {
        const title = '회원권 수정 불가',
          message =
            '입력해주신 회원권 정보 중 빈 값이 존재하여 수정이 불가합니다. 모든 정보를 입력해주세요.';

        await alert(message, title);
      }
    }
  },
  unknown: {
    async handler(data) {
      await alert(
        '아래의 오류로 인해 회원권 정보가 저장되지 않았습니다. \n' +
          JSON.stringify(data),
        '회원권 수정 불가'
      );
    }
  }
};

export const HOLDING_CREATE_FAIL_MESSAGES = {
  error_code: {
    '100': {
      async handler({ data }) {
        const title = '홀딩 등록 불가',
          message = data.error_detail;

        await alert(message, title);
      }
    },

    '101': {
      async handler({ data }) {
        const title = '홀딩 등록 불가',
          message = data.error_detail;

        await alert(message, title);
      }
    },

    '102': {
      async handler({ data }) {
        const title = '홀딩 등록 불가',
          message = data.error_detail;

        await alert(message, title);
      }
    }
  },
  unknown: {
    async handler(data) {
      await alert(
        '아래의 오류로 인해 홀딩이 등록되지 않았습니다. \n' +
          JSON.stringify(data),
        '홀딩 등록 불가'
      );
    }
  }
};

export const HOLDING_UPDATE_FAIL_MESSAGES = {
  error_code: {
    '100': {
      async handler({ data }) {
        const title = '홀딩 수정 불가',
          message = data.error_detail;

        await alert(message, title);
      }
    },

    '101': {
      async handler() {
        const title = '홀딩 수정 불가',
          message = '홀딩 기간은 회원권 기간보다 짧아야 합니다.';

        await alert(message, title);
      }
    },

    '102': {
      async handler() {
        const title = '홀딩 수정 불가',
          message = '기간 내에 이미 다른 홀딩 내역이 존재합니다.';

        await alert(message, title);
      }
    },
    '103': {
      async handler() {
        const title = '홀딩 수정 불가',
          message = '기간 내에 이미 다른 홀딩 내역이 존재합니다.';

        await alert(message, title);
      }
    },

    '801': {
      async handler() {
        const title = '홀딩 수정 불가',
          message =
            '수정 전 홀딩 기간에 이미 예약이 존재합니다. 예약을 취소한 후 진행해주시기 바랍니다.';

        await alert(message, title);
      }
    }
  },
  unknown: {
    async handler(data) {
      await alert(
        '아래의 오류로 인해 홀딩이 등록되지 않았습니다. \n' +
          JSON.stringify(data),
        '홀딩 수정 불가'
      );
    }
  }
};

export const HOLDING_DELETE_FAIL_MESSAGES = {
  error_code: {
    '101': {
      async handler({ data }) {
        const title = '홀딩 삭제 불가',
          message = data.error_detail;

        await alert(message, title);
      }
    }
  },
  unknown: {
    async handler(data) {
      await alert(
        '아래의 오류로 인해 홀딩이 등록되지 않았습니다. \n' +
          JSON.stringify(data),
        '홀딩 수정 불가'
      );
    }
  }
};
